import { DashedTitle, Icon } from '@fasstech/middle-design-system';
import { isGroupOffer, offerCodeEnum } from '@@viewEnums';
import RefundIndividualHealth from './RefundIndividualHealth.jsx';
import PaymentCard from './PaymentCard.jsx';
import GroupHealthPaymentCard from './GroupHealthPaymentCard.jsx';

const Payment = ({
  getMiddleText,
  getMiddleBoolean,
  displayRefundInformation,
  middleFeatures,
  project,
  onEdit,
  offerCode,
  prevTnsCommission,
  isProjectEditable
}) => {
  return (
    <div className="flex flex-col items-center gap-4">
      <Icon name={'circleWallet'} size={50}/>
      <DashedTitle>{getMiddleText('RECAPITULATIF_PAIEMENT_TITLE')}</DashedTitle>
      <div className={'w-full gap-4 flex flex-col md:flex-row! md:justify-between'}>
        {(getMiddleBoolean('PAIEMENTETREMBOURSEMENT_REMBOURSEMENT_EST_NECESSAIRE') ||
            getMiddleBoolean('PAIEMENTETREMBOURSEMENT_RIB_BENEFICIAIRE_EST_NECESSAIRE')) &&
          displayRefundInformation &&
          offerCode === offerCodeEnum.INDIVIDUAL_HEALTH && (
          <RefundIndividualHealth
            project={project}
            getMiddleText={getMiddleText}
            editSouscription3={onEdit}
            getMiddleBoolean={getMiddleBoolean}
            isProjectEditable={isProjectEditable}
          />
        )}
        {isGroupOffer(offerCode) ? (
          <GroupHealthPaymentCard
            project={project}
            getMiddleText={getMiddleText}
            middleFeatures={middleFeatures}
            editSouscription3={onEdit}
            isProjectEditable={isProjectEditable}
          />
        ) : (<PaymentCard
          project={project}
          getMiddleText={getMiddleText}
          middleFeatures={middleFeatures}
          editSouscription3={onEdit}
          offerCode={offerCode}
          prevTnsCommission={prevTnsCommission}
          isProjectEditable={isProjectEditable}
        />)}
      </div>
    </div>
  );
};

export default Payment;
